import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTour } from '../../hooks/useTour';
import { TourPrompt } from '../TourPrompt';
import { WebsiteTour } from '../WebsiteTour';
import { selectUserLoggedIn, RootState } from '../../modules';

export const TourManager: React.FC = () => {
    const isLoggedIn = useSelector((state: RootState) => selectUserLoggedIn(state));
    const {
        isTourVisible,
        showTourPrompt,
        currentStep,
        setCurrentStep,
        startTour,
        skipTour,
        completeTour,
        setIsTourVisible
    } = useTour();

    // Only show tour prompt if user is logged in
    useEffect(() => {
        if (!isLoggedIn && (showTourPrompt || isTourVisible)) {
            skipTour(false); // Don't remember this choice
        }
    }, [isLoggedIn, showTourPrompt, isTourVisible, skipTour]);

    const handleTourClose = () => {
        setIsTourVisible(false);
        completeTour();
    };

    const handleTourChange = (current: number) => {
        setCurrentStep(current);
    };

    const handleSkipTour = (rememberChoice: boolean) => {
        skipTour(rememberChoice);
    };

    // Don't show anything if user is not logged in
    if (!isLoggedIn) {
        return null;
    }

    return (
        <>
            <TourPrompt
                visible={showTourPrompt}
                onStartTour={startTour}
                onSkipTour={handleSkipTour}
            />
            <WebsiteTour
                open={isTourVisible}
                onClose={handleTourClose}
                current={currentStep}
                onChange={handleTourChange}
            />
        </>
    );
};
